import useWidth from '@components/Hooks/useWidth';
import { useIsRachelPage } from './useIsRachelPage';

export type RachelPresentationMode = 'docked' | 'overlay' | 'page' | 'none';

interface RachelPresentationInput {
  isPhone: boolean;
  isTabletDown: boolean;
  isOnPage: boolean;
}

export interface RachelPresentation {
  mode: RachelPresentationMode;
  isOverlaid: boolean;
  isMaximized: boolean;
  canToggleMaximize: boolean;
}

const getRachelPresentationMode = ({
  isPhone,
  isTabletDown,
  isOnPage,
}: RachelPresentationInput): RachelPresentationMode => {
  if (isOnPage) {
    return 'page';
  }

  if (isPhone) {
    return 'none';
  }

  if (isTabletDown) {
    return 'overlay';
  }

  return 'docked';
};

export const useRachelPresentation = (): RachelPresentation => {
  const { mobileWidth, isCustomizedTabletDown } = useWidth();
  const isOnPage = useIsRachelPage();
  const mode = getRachelPresentationMode({
    isPhone: mobileWidth,
    isTabletDown: isCustomizedTabletDown,
    isOnPage,
  });

  return {
    mode,
    isOverlaid: mode === 'overlay',
    isMaximized: mode === 'page',
    canToggleMaximize: !mobileWidth,
  };
};
